import { Typography, TypographyProps } from "@mui/material";
import { NoData } from "./NoData";
import { CommonFieldProps } from "./types";

type TextFieldProps = CommonFieldProps & TypographyProps;

export const TextField = ({
  name,
  data,
  getValue,
  ...rest
}: TextFieldProps) => {
  const value = getValue ? getValue(data) : data[name];

  return value ? <Typography {...rest}>{value}</Typography> : <NoData />;
};
